function isJsonString(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (_) {
      return false;
    }
  }
  
  export const localStorageHealthCheck = async () => {
    try {
      const keys = [];
      for (var i = 0; i < localStorage.length; ++i) {
        const key = localStorage.key(i);
        if (key) keys.push(key);
      }
      for (const key of keys) {
        try {
          const result = window.localStorage.getItem(key);
          if (result && !isJsonString(result)) {
            window.localStorage.removeItem(key);
          }
        } catch (error) {
          window.localStorage.clear();
          console.error('window.localStorage Exception occurred:', error);
        }
      }
    } catch (error) {
      console.error('window.localStorage Exception occurred:', error);
    }
  };
  
  export const storePersist = {
    set: (key, state) => {
      window.localStorage.setItem(key, JSON.stringify(state));
    },
    get: (key) => {
      const result = window.localStorage.getItem(key);
      if (!result) {
        return false;
      } else {
        if (!isJsonString(result)) {
          window.localStorage.removeItem(key);
          return false;
        } else return JSON.parse(result);
      }
    },
    remove: (key) => {
      window.localStorage.removeItem(key);
    },
    getAll: () => {
      return window.localStorage;
    },
    clear: () => {
      window.localStorage.clear();
    },
  };
  
  export default storePersist;
  